export default "__VITE_PUBLIC_ASSET__f5f20ee0__"